import styled from 'styled-components';
import { CommonButton } from '../common/CommonButton';
import { MODAL_TYPE, modalStore } from '../../store/modalStore';
import { RootPortal } from '../common/RootPortal';
import dayjs from 'dayjs';
import { IS_TAB_OPEN_DATE } from '../../hook/useDateHook';
import 'dayjs/locale/ko';

dayjs.locale('ko');

export const CommonModal = () => {
  const { isVisibleCommon, modalType, hideModal, commonCallback1, commonCallback2 } = modalStore();
  return (
    <RootPortal>
      <ModalWrap $visible={isVisibleCommon}>
        <Dim />
        <ModalContent $visible={isVisibleCommon}>
          <Content style={{ height: modalType === MODAL_TYPE.REAL_NOT_AGREE ? 125 : 104 }}>
            {modalType === MODAL_TYPE.NOT_START && (
              <ContentText>
                {dayjs(IS_TAB_OPEN_DATE).format('M월 D일(dd)')} 새틀라이트가
                <br /> 시작되면 확인이 가능합니다!
              </ContentText>
            )}
            {modalType === MODAL_TYPE.CHECK_TICKET && (
              <ContentText>참가권 획득 후 클릭해주세요!</ContentText>
            )}
            {modalType === MODAL_TYPE.IS_AGREE_PRIVACY && (
              <ContentText>
                개인정보 3자 제공
                <br />
                동의 여부를 선택해주세요.
              </ContentText>
            )}
            {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
              <ContentText>
                동의하지 않을경우 <br />
                참가권을 획득했어도 토너먼트
                <br />
                참여가 불가능합니다.
              </ContentText>
            )}
            {modalType === MODAL_TYPE.CHECK_AGREE && (
              <ContentText>
                개인정보 3자 제공
                <br />
                동의 여부를 선택해주세요.
              </ContentText>
            )}
            {modalType === MODAL_TYPE.COMPLETE_AGREE && (
              <ContentText>
                개인정보 3자 제공
                <br /> 동의가 완료 되었습니다.
              </ContentText>
            )}

            {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
              <RealAgreeText>정말 미동의 하시겠습니까?</RealAgreeText>
            )}
            {modalType === MODAL_TYPE.COMPLETE_AGREE && (
              <CheckTournamentText>토너먼트 진행 내용을 확인해주세요!</CheckTournamentText>
            )}
          </Content>

          {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
            <ButtonRowContainer>
              <CommonButton
                click={() => {
                  if (commonCallback2) {
                    commonCallback2();
                  }
                  hideModal();
                }}
                text="미동의"
                theme={'dark'}
              />
              <CommonButton
                click={() => {
                  if (commonCallback1) {
                    commonCallback1();
                  }
                  hideModal();
                }}
                text="다시 선택"
              />
            </ButtonRowContainer>
          )}
          {modalType !== MODAL_TYPE.REAL_NOT_AGREE && (
            <ButtonContainer
              onClick={() => {
                if (commonCallback1) {
                  commonCallback1();
                }
                hideModal();
              }}
            >
              <CommonButton text="확인" />
            </ButtonContainer>
          )}
        </ModalContent>
      </ModalWrap>
    </RootPortal>
  );
};

const ButtonRowContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;

  > div:first-child {
    button {
      border-radius: 0;
      border-bottom-left-radius: 20px;
    }
  }

  > div:last-child {
    button {
      border-radius: 0;
      border-bottom-right-radius: 20px;
    }
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;

  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  width: 90%;
  max-height: 80%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;
  max-width: 720px;
`;

const Content = styled.div`
  border-radius: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: -0.3px;
`;

const RealAgreeText = styled.p`
  color: #f86855;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.56px;
  margin-top: 4px;
`;

const CheckTournamentText = styled.p`
  margin-top: 4px;
  color: #b2b2b2;
  text-align: center;
  font-size: 14px;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.7px;
`;
